﻿import Image from "../image";
import ActivePage from "../activePage";

export default class InventionPage extends ActivePage {

    constructor() {
        super();
        this.image = new Image();
        this.caseNumberSearchValueMapperUrl = "";
        this.previousClient = null;
        this.previousBusinessLine = null;       /*SABIC MOD*/
        this.previousBusinessUnit = null;       /*SABIC MOD*/
    }

    init(addMode, isClientMatterOn, screen) {
        this.tabsLoaded = [];
        this.tabChangeSetListener();

        $(document).ready(() => {
            if (addMode) {

                if (isClientMatterOn) {
                    const client = this.getKendoComboBox("ClientID");
                    client.input.focus();
                }
                else {
                    const respOffice = this.getKendoComboBox("RespOffice");
                    if (respOffice) {
                        respOffice.input.focus();
                    }
                    else {
                        const caseNumber = this.getElement("CaseNumber");
                        caseNumber.focus();
                    }
                }

            }

            const atty1 = this.getKendoComboBox("Attorney1ID");
            const atty2 = this.getKendoComboBox("Attorney2ID");
            const atty3 = this.getKendoComboBox("Attorney3ID");
            const atty4 = this.getKendoComboBox("Attorney4ID");
            const atty5 = this.getKendoComboBox("Attorney5ID");

            const self = this;
            $("input[name='ClientID']").change(function () {
                const baseUrl = $("body").data("base-url");
                $.ajax({
                    url: `${baseUrl}/Shared/Client/GetPatDefaultAttorney`,
                    data: { clientId: this.value },
                    dataType: 'json',
                    success: function (data) {
                        if (data.length > 0) {

                            if ((atty1.value() == '' && data[0].PatAttorney1ID != null) ||
                                (self.previousClient != null && atty1.value() == self.previousClient[0].PatAttorney1ID)) {
                                atty1.value(data[0].PatAttorney1ID);
                                atty1.element.trigger("change");
                            }
                            if ((atty2.value() == '' && data[0].PatAttorney2ID != null) ||
                                (self.previousClient != null && atty2.value() == self.previousClient[0].PatAttorney2ID)) {
                                atty2.value(data[0].PatAttorney2ID);
                                atty2.element.trigger("change");
                            }
                            if ((atty3.value() == '' && data[0].PatAttorney3ID != null) ||
                                (self.previousClient != null && atty3.value() == self.previousClient[0].PatAttorney3ID)) {
                                atty3.value(data[0].PatAttorney3ID);
                                atty3.element.trigger("change");
                            }
                            if ((atty4.value() == '' && data[0].PatAttorney4ID != null) ||
                                (self.previousClient != null && atty4.value() == self.previousClient[0].PatAttorney4ID)) {
                                atty4.value(data[0].PatAttorney4ID);
                                atty4.element.trigger("change");
                            }
                            if ((atty5.value() == '' && data[0].PatAttorney5ID != null) ||
                                (self.previousClient != null && atty5.value() == self.previousClient[0].PatAttorney5ID)) {
                                atty5.value(data[0].PatAttorney5ID);
                                atty5.element.trigger("change");
                            }
                            self.previousClient = data;
                        }
                    }
                });
            })

            /*SABIC MOD START*/
            const businessUnit = this.getKendoComboBox("BusinessUnitID");

            $("input[name='BusinessLineID']").change(function () {
                const baseUrl = $("body").data("base-url");
                $.ajax({
                    url: `${baseUrl}/Shared/BusinessLine/GetDefaultBusinessUnit`,
                    data: { businessLineId: this.value },
                    dataType: 'json',
                    success: function (data) {
                        if (data.length > 0) {

                            if ((businessUnit.value() == '' && data[0].DefaultBusinessUnitID != null) ||
                                (self.previousBusinessLine != null && businessUnit.value() == self.previousBusinessLine[0].DefaultBusinessUnitID)) {
                                businessUnit.value(data[0].DefaultBusinessUnitID);
                                businessUnit.element.trigger("change");
                            }
                            self.previousBusinessLine = data;
                        }
                    }
                });
            })

            const client = this.getKendoComboBox("ClientID");

            $("input[name='BusinessUnitID']").change(function () {
                const baseUrl = $("body").data("base-url");
                $.ajax({
                    url: `${baseUrl}/Shared/BusinessUnit/GetDefaultClient`,
                    data: { businessUnitId: this.value },
                    dataType: 'json',
                    success: function (data) {
                        if (data.length > 0) {

                            if ((client.value() == '' && data[0].DefaultClientID != null) ||
                                (self.previousBusinessUnit != null && client.value() == self.previousBusinessUnit[0].DefaultClientID)) {
                                client.value(data[0].DefaultClientID);
                                client.element.trigger("change");
                            }
                            self.previousBusinessUnit = data;
                        }
                    }
                });
            })
            /*SABIC MOD END*/

            const ownersGrid = $(`#ownersGrid_${screen}`);
            ownersGrid.on("click", ".ownerLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = ownersGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.OwnerID);
                pageHelper.openLink(linkUrl, false);
            });

            const departmentsGrid = $(`#departmentsGrid_${screen}`);
            departmentsGrid.on("click", ".departmentLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = departmentsGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.DepartmentId);
                pageHelper.openLink(linkUrl, false);
            });

            const respDepartmentsGrid = $(`#respDepartmentsGrid_${screen}`);
            respDepartmentsGrid.on("click", ".departmentLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = respDepartmentsGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.DepartmentId);
                pageHelper.openLink(linkUrl, false);
            });

            const inventorsGrid = $(`#inventorsGrid_${screen}`);
            inventorsGrid.on("click", ".inventorLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = inventorsGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.InventorID);
                pageHelper.openLink(linkUrl, false);
            });

            const prioritiesGrid = $("#inventionPriorityGrid");
            prioritiesGrid.on("click", ".appLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = prioritiesGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.ParentAppId);
                pageHelper.openLink(linkUrl, false);
            });

            const applicationsGrid = $("#inventionApplicationGrid");
            applicationsGrid.on("click", ".appLink", (e) => {
                e.stopPropagation();
                e.preventDefault();

                if (inventionPage.applicationAppIds && inventionPage.applicationAppIds.length > 0) {
                    patCountryAppPage.mainSearchRecordIds = inventionPage.applicationAppIds;
                }
                const link = $(e.target);
                pageHelper.openDetailsLink(link);
            });


        });

        if (!addMode) {
            this.emphasizeRespDepartmentRequired(screen);
        }
    }

    emphasizeRespDepartmentRequired = (screen) => {
        $(document).ready(async () => {
            const form = $(`#${screen}`).find("form");
            const invId = form.find("#InvId").val();

            if (!invId || invId === "0") {
                return;
            }

            const baseUrl = $("body").data("base-url");
            const checkUrl = `${baseUrl}/Patent/Invention/CheckIfRespDepartmentExist`;
            const respDepartmentExists = await $.get(checkUrl, { invId });

            if (!respDepartmentExists) {
                const title = "Notice";
                const msg = "Stake Holder Department is required.Please select a Stake Holder Department in the Entities tab.";


                cpiConfirm.confirm(title, msg, null, {
                    "action": { "class": "btn-primary d-none" },
                    "close": { "class": "btn-secondary d-none" }
                });
            }

        });
    }

    caseNumberSearchValueMapper = (options) => {
        let url = this.getCaseNumberSearchValueMapper();

        if (!url)
            url = `${$("body").data("base-url")}/Patent/Invention/CaseNumberSearchValueMapper`;

        $.ajax({
            url: url,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    getCaseNumberSearchValueMapper = () => {
        if (this.caseNumberSearchValueMapperUrl === "") {
            this.caseNumberSearchValueMapperUrl = $("#inventionSearchCaseInfoTabContent").data("case-number-mapper-url");
            if (this.caseNumberSearchValueMapperUrl === undefined || this.caseNumberSearchValueMapperUrl === "")
                this.caseNumberSearchValueMapperUrl = $("#docMgtMainTabContent").data("case-number-mapper-url");
        }
        return this.caseNumberSearchValueMapperUrl;
    }

    titleSearchValueMapper(options) {
        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/Patent/Invention/TitleSearchValueMapper`;
        $.ajax({
            url: url,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    tabChangeSetListener = () => {
        $('#inventionDetailTab a').on('click',
            (e) => {
                e.preventDefault();
                const tab = e.target.id;
                if (this.tabsLoaded.indexOf(tab) === -1) {
                    this.tabsLoaded.push(tab);
                    this.loadTabContent(tab);
                }
            });
    }

    loadTabContent(tab) {
        const pageId = this.mainDetailContainer;

        switch (tab) {
            case "inventionDetailEntitiesTab":
                $(document).ready(function () {
                    const ownersGrid = $(`#ownersGrid_${pageId}`).data("kendoGrid");
                    const inventorsGrid = $(`#inventorsGrid_${pageId}`).data("kendoGrid");
                    const departmentsGrid = $(`#departmentsGrid_${pageId}`).data("kendoGrid");
                    const respDepartmentsGrid = $(`#respDepartmentsGrid_${pageId}`).data("kendoGrid");

                    if (ownersGrid) {
                        ownersGrid.dataSource.read();
                    }

                    if (inventorsGrid) {
                        inventorsGrid.dataSource.read();
                    }

                    if (departmentsGrid) {
                        departmentsGrid.dataSource.read();
                    }

                    if (respDepartmentsGrid) {
                        respDepartmentsGrid.dataSource.read();
                    }

                    
                });
                
                break;
            case "inventionDetailPrioritiesTab":
                $(document).ready(function () {
                    const grid = $("#inventionPriorityGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "inventionDetailAbstractTab":
                $(document).ready(function () {
                    const grid = $("#inventionAbstractGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "inventionDetailKeywordsTab":
                $(document).ready(function () {
                    const grid = $(`#keywordsGrid${pageId}`).data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "inventionDetailDocumentsTab":
                $(document).ready(() => {
                    this.image.initializeImage(this);
                });
                break;
            case "inventionDetailApplicationsTab":
                $(document).ready(() => {
                    const appGrid = $("#inventionApplicationGrid");
                    const grid = appGrid.data("kendoGrid");
                    grid.dataSource.read();
                    pageHelper.addBreadCrumbsRefreshHandler(appGrid, () => {
                        grid.dataSource.read();
                        const prioritiesGrid = $("#inventionPriorityGrid").data("kendoGrid");
                        prioritiesGrid.dataSource.read();
                        this.refreshCaseInfo();
                        this.updateRecordStamps();
                    });
                });
                break;
            case "inventionDetailRelatedInventionsTab":
                $(document).ready(function () {
                    const grid = $("#inventionRelatedInventionsGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;

            //SABIC MOD START
            case "inventionDetailObservationsTab":
                $(document).ready(function () {
                    const grid = $("#inventionObservationGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "inventionDetailTechProdTypesTab":
                $(document).ready(function () {
                    const grid = $("#inventionTechProdTypeGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            //SABIC MOD END

            case "inventionDetailRelatedDisclosuresTab":
                $(document).ready(function () {
                    const grid = $("#inventionRelatedDisclosuresGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "inventionDetailRelatedMatterTab":
                $(document).ready(() => {
                    const relatedMattersGrid = $(`#relatedMattersGrid_${this.mainDetailContainer}`);
                    const grid = relatedMattersGrid.data("kendoGrid");
                    grid.dataSource.read();
                    pageHelper.addBreadCrumbsRefreshHandler(relatedMattersGrid, () => { grid.dataSource.read() });
                });
                break;
            case "inventionDetailCorrespondenceTab":
                $(document).ready(() => {
                    const grid = $(`#docsOutGrid_${this.mainDetailContainer}`).data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "inventionInventorRemunerationTab":
                $(document).ready(() => {
                    //const grid = $(`#inventionInventorRemunerationCostGrid`).data("kendoGrid");
                    //grid.dataSource.read();
                });
                break;



            case "":
                break;
        }
    }

    onComboBoxSelect(e, name) {
        if (e.item) {
            const element = e.sender.element.closest('td').next('td');
            if (element.length > 0) {
                const value = e.dataItem[name];
                if (element.is("input"))
                    element.val(value);
                else
                    element.html(value);
            }
        }
    }

    onAppNumberComboBoxSelect(e) {
        if (e.dataItem) {
            const grid = $("#inventionPriorityGrid").data("kendoGrid");
            const dataItem = grid.dataItem(grid.select());
            dataItem.ParentAppId = e.dataItem["AppId"];

            dataItem.set('FilDate', e.dataItem["FilDate"]);
            dataItem.set('CaseType', e.dataItem["CaseType"]);
            dataItem.set('Country', e.dataItem["Country"]);
        }
    }

    refreshGrid = function (name) {
        const grid = $("#" + name);
        grid.data("kendoGrid").dataSource.read();
    };

    onAddCountryApplication = function () {
        return $.ajax({
            url: "/r9/Patent/CountryApplication/Add",
            data: { fromSearch: false }
        });
    }


    applicationsTabFilter(element, property) {
        element.kendoDropDownList({
            dataSource: {
                transport: {
                    read: '../../CountryApplication/GetPicklistData?property=Property'.replace('Property', property)
                }
            },
            optionLabel: "--Select Value--"
        });
    }

    hintInventor(element) {
        const table = $('<table style="width: 600px;" class="k-grid k-widget"></table>');
        table.append(element.clone()); //append the dragged element
        table.css("opacity", 0.7);
        return table; //return the hint element
    }

    placeholderInventor() {
        return $('<tr colspan="4" class="placeholder"></tr>');
    }

    onEditInventor(e) {
        const gridId = e.sender.element[0].id;
        if (e.model.isNew()) {
            //Remove move class on newly added row as we do not want to move record which is not yet saved.
            $("#" + gridId + " tbody").find("tr[data-uid=" + e.model.uid + "]")
                .css({ 'cursor': "default", 'HintHandler': '', });
            $("#" + gridId + " tbody").find("tr[data-uid=" + e.model.uid + "]").removeAttr("onChange");
        }
    }

    onChange_RelatedDisclosure = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");

            const disclosureStatus = e.dataItem["DisclosureStatus"];
            const disclosureDate = e.dataItem["DisclosureDate"];
            const clientCode = e.dataItem["ClientCode"];
            const title = e.dataItem["DisclosureTitle"];
            const recommendation = e.dataItem["Recommendation"];

            const grid = $("#inventionRelatedDisclosuresGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);

            dataItem.DMSId = e.dataItem["DMSId"];
            dataItem.DisclosureStatus = disclosureStatus;
            dataItem.DisclosureDate = disclosureDate;
            dataItem.ClientCode = clientCode;
            dataItem.DiscTitle = title;
            dataItem.Recommendation = recommendation;

            $(row).find(".status-field").html(kendo.htmlEncode(disclosureStatus));
            $(row).find(".date-field").html(kendo.htmlEncode(disclosureDate));
            $(row).find(".client-field").html(kendo.htmlEncode(clientCode));
            $(row).find(".title-field").html(kendo.htmlEncode(title));
            $(row).find(".recommendation-field").html(kendo.htmlEncode(recommendation));
        }
    }

    //------------------------------------------------------------ COPY
    showCopyScreen() {
        //const popupContainer = $(".cpiContainerPopup").last();
        const popupContainer = $(".site-content .popup").last();
        const dialogContainer = popupContainer.find("#patInvCopyDialog");
        let entryForm = dialogContainer.find("form")[0];
        dialogContainer.modal("show");
        const self = this;

        //$(dialogContainer.find("#tmkCopyButton")).click(function () { self.copyTrademarks(); });

        entryForm = $(entryForm);
        const afterSubmit = function (result) {
            const dataContainer = $('#' + self.mainDetailContainer).find(".cpiDataContainer");
            if (dataContainer.length > 0) {
                setTimeout(function () {
                    dataContainer.empty();
                    dataContainer.html(result);
                }, 1000);
            }
        };
        entryForm.cpiPopupEntryForm({ dialogContainer: dialogContainer, afterSubmit: afterSubmit });
    }

    mainCopyInitialize = (copyInvId) => {
        const baseUrl = $("body").data("base-url");
        const mainUrl = `${baseUrl}/Patent/Invention/`;

        $(document).ready(() => {
            const container = $("#patInvCopyDialog");
            container.find(".case-info-settings").hide();

            container.on("click", ".case-info-set", () => {
                container.find(".case-info-settings").show();
                container.find(".data-to-copy").hide();

                const url = `${mainUrl}GetCopySettings`;
                $.get(url, { copyInvId: copyInvId })
                    .done(function (result) {
                        container.find(".case-info-settings-fields").html(result);
                    })
                    .fail(function (e) {
                        pageHelper.showErrors(e.responseText);
                    });
            });
            container.on("click", ".case-info-set-cancel,.case-info-set-save", () => {
                container.find(".case-info-settings").hide();
                container.find(".data-to-copy").show();
            });
            container.on("change", ".case-info-settings-fields input[type='checkbox']", function () {
                const checkbox = $(this);
                const name = checkbox.attr("name");
                const value = checkbox.prop("checked");
                const url = `${mainUrl}UpdateCopySetting`;
                $.post(url, { copySettingId: name, copy: value })
                    .fail(function (e) {
                        pageHelper.showErrors(e.responseText);
                    });
            });
        });
    }

    refreshCaseInfo() {
        const baseUrl = $("body").data("base-url");
        $.get(`${baseUrl}/Patent/Invention/GetDetails`, { id: this.currentRecordId })
            .done((data) => {
                const comboBox = this.getKendoComboBox("DisclosureStatus");
                comboBox.value(data.DisclosureStatus);
            })
            .fail(function (e) {
                pageHelper.showErrors(e.responseText);
            });
    }

    applicationsGridDataBound = (e) => {
        const grid = $("#inventionApplicationGrid").data("kendoGrid");
        const dataSource = grid.dataSource;
        const data = dataSource.data();
        const sort = dataSource.sort();
        const query = new kendo.data.Query(data);
        const sortedData = query.sort(sort).data;
        this.applicationAppIds = sortedData.map(e => e.AppId);
    }

    /* related invention */
    onChange_RelatedInvention = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");

            const invTitle = e.dataItem["InvTitle"];
            const disclosureStatus = e.dataItem["DisclosureStatus"];
            const disclosureDate = e.dataItem["DisclosureDate"];

            const grid = $("#inventionRelatedInventionsGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.RelatedInvId = e.dataItem["InvId"];
            dataItem.InvTitle = invTitle;
            dataItem.DisclosureStatus = disclosureStatus;
            dataItem.DisclosureDate = disclosureDate;

            $(row).find(".title-field").html(kendo.htmlEncode(invTitle));
            $(row).find(".status-field").html(kendo.htmlEncode(disclosureStatus));
            $(row).find(".date-field").html(kendo.htmlEncode(disclosureDate));
        }
    }

    showDetails(result) {
        let id = result;
        if (isNaN(result))
            id = result.id;

        pageHelper.showDetails(this, id, () => {
            pageHelper.handleEmailWorkflow(result);
        });
    }

    countryApplicationSearchParam = () => {
        const CountryApplicationInvId = document.getElementById("CountryApplicationInvId").value;
        const CountryApplicationCaseNumber = document.getElementById("CountryApplicationCaseNumber_patInventionDetail").value;
        const CountryApplicationCountry = document.getElementById("CountryApplicationCountry_patInventionDetail").value;
        const CountryApplicationSubCase = document.getElementById("CountryApplicationSubCase_patInventionDetail").value;
        const CountryApplicationCaseType = document.getElementById("CountryApplicationCaseType_patInventionDetail").value;
        const CountryApplicationStatus = document.getElementById("CountryApplicationStatus_patInventionDetail").value;
        const CountryApplicationAppNumber = document.getElementById("CountryApplicationAppNumber_patInventionDetail").value;
        const FilDateFrom = document.getElementById("FilDateFrom_patInventionDetail").value !== "" ? new Date(document.getElementById("FilDateFrom_patInventionDetail").value) : "";
        const FilDateTo = document.getElementById("FilDateTo_patInventionDetail").value !== "" ? new Date(document.getElementById("FilDateTo_patInventionDetail").value) : "";
        const CountryApplicationPatNumber = document.getElementById("CountryApplicationPatNumber_patInventionDetail").value;
        const IssDateFrom = document.getElementById("IssDateFrom_patInventionDetail").value !== "" ? new Date(document.getElementById("IssDateFrom_patInventionDetail").value) : "";
        const IssDateTo = document.getElementById("IssDateTo_patInventionDetail").value !== "" ? new Date(document.getElementById("IssDateTo_patInventionDetail").value) : "";
        return {
            CountryApplicationInvId: CountryApplicationInvId,
            CountryApplicationCaseNumber: CountryApplicationCaseNumber,
            CountryApplicationCountry: CountryApplicationCountry,
            CountryApplicationSubCase: CountryApplicationSubCase,
            CountryApplicationCaseType: CountryApplicationCaseType,
            CountryApplicationStatus: CountryApplicationStatus,
            CountryApplicationAppNumber: CountryApplicationAppNumber,
            FilDateFrom: FilDateFrom,
            FilDateTo: FilDateTo,
            CountryApplicationPatNumber: CountryApplicationPatNumber,
            IssDateFrom: IssDateFrom,
            IssDateTo: IssDateTo
        };
    };

    CountryApplicationGridRead = () => {
        const countryApplicationsGrid = $("#inventionApplicationGrid").data("kendoGrid");
        countryApplicationsGrid.dataSource.read();
    };
}